import React from 'react';
import { useIntl } from 'react-intl';
import { CircularProgress, Grid, TextField, Typography, Box } from '@mui/material';
import { DateTimePicker, EzFormControl, YesNoRadioGroup } from 'wobi-web-common';
import PropTypes from 'prop-types';
import moment from 'moment';
import SimulatorExpansionPanel from '../../components/SimulatorComponents/ExpansionPanel';
import useStyles from './useStyles';

const FollowUpCall = React.memo(({
  handleDateChange,
  formikSetField,
  formikValues,
  isFollowUpLoading,
  maxDate,
  minDate,
}) => {
  const intl = useIntl();
  const { classes } = useStyles();
  const messages = (id) => intl.formatMessage({ id });

  const handlePhoneNumberChange = (event) => {
    const { value } = event.target;
    formikSetField('followupPhoneNumber', value);
  };

  const handleIsSaleInProgressChange = (value) => {
    const isSaleInProgress = value === 'yes';
    formikSetField('isSaleInProgress', isSaleInProgress);
  };

  const disableHolidays = (date) => {
    const SATURDAY_DAY = 6;
    const day = moment(date).day();
    if (day === SATURDAY_DAY) {
      return true;
    }

    return false;
  };

  return (
    <SimulatorExpansionPanel title={<Typography>{messages('simulator.title.followup.call')}</Typography>}>
      {isFollowUpLoading ? (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 38, width: '100%' }}>
          <CircularProgress size={20} />
        </Box>
      ) : (
        <Grid container sx={{ rowGap: '12px' }}>
          
          <Grid container item size={12}>
            <Grid className={classes.subtitle} size={4}>
              {messages('simulator.title.needs.followup.call')}
            </Grid>
            <Grid size={8}>
              <EzFormControl name='isSaleInProgress' isLabelInChild>
                <YesNoRadioGroup
                  value={formikValues.isSaleInProgress ? 'yes' : formikValues.isSaleInProgress === null ? '' : 'no'}
                  onChange={(event, value) => handleIsSaleInProgressChange(value)}
                />
              </EzFormControl>
            </Grid>
          </Grid>

          {formikValues.isSaleInProgress === false && (
            <Grid container item size={12} sx={{ rowGap: '12px' }}>
              
              <Grid container item size={12}>
                <Grid className={classes.subtitle} size={4}>
                  {messages('simulator.title.followup.call.schedule.date')}
                </Grid>
                <Grid size={4}>
                  <EzFormControl
                    name='followupCallDate'
                    label={messages('simulator.title.followup.call.schedule.date.label')}
                    isLabelInChild
                  >
                    <DateTimePicker
                      ampm={false}
                      value={formikValues.followupCallDate}
                      onChange={(date) => handleDateChange(date)}
                      onAccept={() => {}}
                      autoOk
                      id='followupCallDate'
                      openTo='date'
                      shouldDisableDate={disableHolidays}
                      maxDate={maxDate ? moment(maxDate).format('YYYY-MM-DD') : undefined}
                      minDate={minDate ? moment(minDate).format('YYYY-MM-DD') : undefined}
                      variant='inline'
                      size='small'
                    />
                  </EzFormControl>
                </Grid>
              </Grid>

              <Grid container item size={12}>
                <Grid className={classes.subtitle} size={4}>
                  {messages('simulator.title.followup.call.phone.number')}
                </Grid>
                <Grid size={4}>
                  <EzFormControl
                    name='followupPhoneNumber'
                    label={messages('simulator.title.followup.call.phone.number.label')}
                    isLabelInChild
                  >
                    <TextField
                      id='followupPhoneNumber'
                      autoComplete='off'
                      label='טלפון'
                      onChange={(e) => {
                        e.target.value = e.target.value.replace(/\D/g, '');
                        handlePhoneNumberChange(e);
                      }}
                      value={formikValues.followupPhoneNumber}
                      size='small'
                    />
                  </EzFormControl>
                </Grid>
              </Grid>

            </Grid>
          )}
        </Grid>
      )}
    </SimulatorExpansionPanel>
  );
});

FollowUpCall.propTypes = {
  formikHandleChange: PropTypes.func,
  formikSetField: PropTypes.func,
  formikValues: PropTypes.object,
  handleDateChange: PropTypes.func,
  isAgentAllowedToFollowupCall: PropTypes.bool,
  isFollowUpLoading: PropTypes.bool,
  maxDate: PropTypes.string,
  minDate: PropTypes.string,
};

export default FollowUpCall;